import { render, staticRenderFns } from "./HeaderBox.vue?vue&type=template&id=04fb0aec"
import script from "./HeaderBox.vue?vue&type=script&lang=js"
export * from "./HeaderBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports